import React from "react";

const iconLink =
  "inline-flex items-center justify-center w-8 h-8 rounded-md text-gray-500 hover:text-[#064E8D] hover:bg-gray-100 transition-colors no-underline";
const iconDanger =
  "inline-flex items-center justify-center w-8 h-8 rounded-md text-gray-500 hover:text-red-600 hover:bg-red-50 transition-colors";

const FreightOrderDtActions = ({ row, onDelete, getNavigate }) => {
  const id = row?.id;
  if (id == null) return null;

  const go = (path) => {
    const nav = getNavigate?.();
    if (typeof nav === "function") {
      nav(path);
      return;
    }
    window.location.assign(path);
  };

  return (
    <div className="flex flex-row flex-nowrap items-center justify-center gap-0.5">
      <a
        href={`/freight/orders/${id}`}
        className={iconLink}
        title="View order"
        onClick={(e) => {
          e.preventDefault();
          go(`/freight/orders/${id}`);
        }}
      >
        <i className="fas fa-eye text-sm" aria-hidden />
      </a>
      <a
        href={`/freight/orders/${id}/edit`}
        className={iconLink}
        title="Edit order"
        onClick={(e) => {
          e.preventDefault();
          go(`/freight/orders/${id}/edit`);
        }}
      >
        <i className="fas fa-pen text-sm" aria-hidden />
      </a>
      <button
        type="button"
        className={iconDanger}
        title="Delete order"
        onClick={() => onDelete?.(row)}
      >
        <i className="fas fa-trash-alt text-sm" aria-hidden />
      </button>
    </div>
  );
};

export default FreightOrderDtActions;
